import { IActionItem, SmartActionButton } from "@components/smart/smartFormGroup/SmartActionButton";
import { IFormGroupDef } from "@components/smart/smartFormGroup/SmartFormGroup";
import BindingContext from "@odata/BindingContext";
import React from "react";

import { TextAlign } from "../../enums";
import { ButtonGroupStyled } from "./VirtualizedForm.styles";
import {
    CUSTOMIZE_FIELDS_ACTION,
    getHidableFields,
    getVisibleFields,
    TSmartVirtualizedFormStorage
} from "./VirtualizedForm.utils";
import VirtualizedFormGroupCustomizationDialog from "./VirtualizedFormGroupCustomizationDialog";


interface IFormGroupFooterProps {
    storage: TSmartVirtualizedFormStorage;
    def: IFormGroupDef;
    bindingContext: BindingContext;
    actions: IActionItem[];
    onSelectRows?: (selectedRows: string[], bc: BindingContext, def: IFormGroupDef) => void;
    onGroupAction?: (action: { id: string, groupId: string }) => void;
}

interface IState {
    isDialogOpened: boolean;
}

export default class VirtualizedFormGroupFooter extends React.PureComponent<IFormGroupFooterProps, IState> {

    get hidableFields(): string[] {
        return getHidableFields(this.props.storage, this.props.bindingContext, this.props.def);
    }

    handleCustomButtonAction = (id: string): void => {
        if (id === CUSTOMIZE_FIELDS_ACTION) {
            this.setState({ isDialogOpened: true });
        } else {
            this.props.onGroupAction?.({ id, groupId: this.props.def.id });
        }
    };

    handleCustomizationDialogConfirm = (selectedRows: string[]): void => {
        this.props.onSelectRows?.(selectedRows, this.props.bindingContext, this.props.def);
        this.handleCustomizationDialogClose();
    }

    handleCustomizationDialogClose = (): void => {
        this.setState({ isDialogOpened: false });
    }

    renderCustomizationDialog(): React.ReactElement {
        const { isDialogOpened } = this.state ?? {};
        if (!isDialogOpened) {
            return null;
        }

        const visibleRows = getVisibleFields(this.props.storage, this.props.bindingContext, this.props.def);

        return (
            <VirtualizedFormGroupCustomizationDialog
                storage={this.props.storage}
                bindingContext={this.props.bindingContext}
                groupDef={this.props.def}
                rows={this.hidableFields}
                visibleRows={visibleRows}
                onConfirm={this.handleCustomizationDialogConfirm}
                onClose={this.handleCustomizationDialogClose}
            />
        );
    }

    render() {
        const { def, actions } = this.props;

        return (<>
            <ButtonGroupStyled align={def.actionsAlignment ?? TextAlign.Left}>
                {actions.map(action => (
                    <SmartActionButton key={action.id} storage={this.props.storage} action={action}
                                       onClick={this.handleCustomButtonAction}/>))}
            </ButtonGroupStyled>
            {this.renderCustomizationDialog()}
            </>);
    }
}
